export const AdvancerStatusKey = {
Active: 'active',
Resolved: 'resolved',
OptedOut: 'optedout',
Orphaned: 'orphaned'
};

export const AdvancerStatusDescription = {
  Active: "Active",
  Resolved: "Resolved",
  OptedOut: "Opted Out",
  Orphaned: "Orphaned"
};

export default [
	{
		id:1,
		key: AdvancerStatusKey.Active,
		description: AdvancerStatusDescription.Active,
	},
	{
		id:2,
		key: AdvancerStatusKey.Resolved,
		description: AdvancerStatusDescription.Resolved,
	},
	{
		id:3,
		key: AdvancerStatusKey.OptedOut,
		description: AdvancerStatusDescription.OptedOut,
	},
	{
		id:4,
		key: AdvancerStatusKey.Orphaned,
		description: AdvancerStatusDescription.Orphaned,
	},
];


// WEBPACK FOOTER //
// ./src/utils/constants/advancerstatus.js